// @module C3.ShoppingExtensions.InventoryList
define('C3.ShoppingExtensions.InventoryList.View'
,	[
	'c3_shoppingextensions_inventorylist.tpl'
	,   'Profile.Model'
	,	'Backbone'
	,   'C3.ShoppingExtensions.InventoryList.Cell.View'
	,   'c3_shoppingextensions_inventorylist_cell.tpl'
	,   'facets_items_collection_view_cell.tpl'
	,   'facets_items_collection_view_row.tpl'
	,   'facets_items_collection.tpl'
	,   'Utils'
	,	'Backbone.CollectionView'
    ]
, function (
	c3_shoppingextensions_inventorylist_tpl
	
	,   ProfileModel
	,	Backbone
	,   InventoryListMacroView
	,   c3_shoppingextensions_inventorylist_cell_tpl
	,   facets_items_collection_view_cell_tpl
	,   facets_items_collection_view_row_tpl
	,   facets_items_collection_tpl
	,   Utils
	,   BackboneCollectionView
)
{
    'use strict';

	// @class C3.ShoppingExtensions.InventoryList.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_inventorylist_tpl

	,	title: Utils.translate('Inventory List Page')

	,	initialize: function (options) {

			
			this.application = options.application;
			this.configuration = this.application.Configuration;
			this.inventoryList = this.configuration.InventoryList;
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			'InventoryList.ProductGroups' : function(){
				var self = this;

				var inventoryListConfig = this.inventoryList.config;
				//console.log(inventoryListConfig);

				var isPhoneDevice = Utils.isPhoneDevice()
				,   viewsPerRowItems = 6;

				if(isPhoneDevice)
				viewsPerRowItems = 3;

				return new BackboneCollectionView({
	                collection: inventoryListConfig ? inventoryListConfig : [],
	                childView: InventoryListMacroView,
	                childTemplate : c3_shoppingextensions_inventorylist_cell_tpl,
	                viewsPerRow: viewsPerRowItems,
	                cellTemplate: facets_items_collection_view_cell_tpl,
	                rowTemplate: facets_items_collection_view_row_tpl,
	                template : facets_items_collection_tpl,
	                childViewOptions: {
	                    application: self.application
	                }
	            });
			}
		}

		//@method getContext @return C3.ShoppingExtensions.InventoryList.View.Context
	,	getContext: function getContext()
		{
			
			return {
				
			};
		}
	});
});
